import React from 'react';
import { createPortal } from 'react-dom';
import { Modal as AppModal } from '../../components/UI';

// HR pop-ups use the app's standard modal (components/UI.js): navy header, red close button, thick black frame,
// blurred backdrop — the same as Payment Voucher, Requisition and the rest. Closing is explicit (× or a button).
// Rendered on <body> (inside an .hr-scope wrapper so the HR styles still apply): an animated screen container would
// otherwise trap the fixed overlay inside it and show it behind the page.
export default function Modal({ title, onClose, children, wide, footer, className = '' }) {
  return createPortal(
    <div className="hr-scope hr-portal">
    <AppModal title={title} onClose={onClose} width={wide ? 960 : 680}>
      <div className={`hr-modal-body ${className}`} role="dialog" aria-label={typeof title === 'string' ? title : undefined}>
        {children}
        {footer && <div className="hr-modal-foot">{footer}</div>}
      </div>
    </AppModal>
    </div>,
    document.body,
  );
}
